/**
 * TemplatesDialog — insert a starter layout (flowchart / kanban / mind map)
 * at the viewport centre via CanvasCore.insertTemplate.
 */
import React from 'react';
import { createPortal } from 'react-dom';
import { X, Workflow, KanbanSquare, Network, Columns3, Grid2x2, GitCommitHorizontal, Network as OrgIcon, Route } from 'lucide-react';
import { T } from '../../../components/em/ui';
import { TEMPLATES } from './canvasConstants';

const ICONS = {
  flowchart: Workflow, kanban: KanbanSquare, mindmap: Network,
  retro: Columns3, swot: Grid2x2, timeline: GitCommitHorizontal, orgchart: OrgIcon, journey: Route,
};

export default function TemplatesDialog({ api, onClose }) {
  const insert = (id) => { api?.insertTemplate?.(id); onClose(); };

  return createPortal(
    <div onMouseDown={onClose} style={{ position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(10,12,20,0.5)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onMouseDown={(e) => e.stopPropagation()} style={{ width: 640, maxWidth: '92vw', maxHeight: '86vh', display: 'flex', flexDirection: 'column', background: T.bgCard, border: `1px solid ${T.border}`, borderRadius: 18, boxShadow: '0 30px 80px -20px rgba(0,0,0,0.5)', overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 18px', borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
          <span style={{ font: `700 16px ${T.font}`, color: T.fg1 }}>Insert a template</span>
          <button type="button" onClick={onClose} style={{ border: 0, background: 'transparent', cursor: 'pointer', color: T.fg5, display: 'flex' }}><X size={18} /></button>
        </div>
        {/* 2-column grid keeps the dialog short enough to fit typical viewports;
            still scrolls internally (header stays put) as a safety net on very
            short windows. */}
        <div style={{ padding: 14, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, overflowY: 'auto' }}>
          {TEMPLATES.map((t) => {
            const Icon = ICONS[t.id] || Workflow;
            return (
              <button key={t.id} type="button" onClick={() => insert(t.id)}
                style={{ display: 'flex', alignItems: 'center', gap: 13, textAlign: 'left', padding: '13px 14px', borderRadius: 12, cursor: 'pointer', border: `1px solid ${T.border}`, background: 'transparent', transition: 'background .12s, border-color .12s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = T.orange50; e.currentTarget.style.borderColor = T.orange; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = T.border; }}>
                <span style={{ width: 40, height: 40, borderRadius: 10, background: T.orange50, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon size={20} color={T.orange} />
                </span>
                <span style={{ minWidth: 0 }}>
                  <span style={{ display: 'block', font: `700 14px ${T.font}`, color: T.fg1 }}>{t.label}</span>
                  <span style={{ display: 'block', font: `400 12px ${T.font}`, color: T.fg5, marginTop: 2 }}>{t.desc}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
}
